/*eslint no-console: 0*/

import AppPanel from '../../fw/AppPanel.react';
import React from 'react';
import Relay from 'react-relay';
import {FormattedMessage, injectIntl, IntlShape} from 'react-intl';
import Link from 'react-router/lib/Link';
import types from '../../../common/model-api/types';
import InvokeChannelJobMutation from '../InvokeChannelJobMutation.react';
import {wrapNotFound} from '../../app/NotFoundHandler.react';
import "../channel.scss";
import ChannelHeader from '../ChannelHeader.react';
import channelViewParent from '../channelViewParent.react';
import ChannelIcon from '../../channel-defs/ChannelIcon.react';
import meQuery from '../../queries/MeQuery';
import RemovedChannelView from './companySearchViewChannelEl.react';
import urlMapping from '../../app/URLMapping';

import '../../layout.scss';
import './companySearch.scss';
import {safeJSONparse} from "../../../common/util/safeJSONparse";
import * as BrowserPermission from '../../BrowserPermission';
import * as Permission from '../../../common/util/Permission';
import {getLastOrganisationId} from '../../app/LastOrganisationId';

class CompanySearch extends channelViewParent {

	constructor(props) {
		super(props);

		let selectedChannels = [];
		let removedChannels = [];

		if (props.user.organisation.channel.options) {
			this.options = safeJSONparse(props.user.organisation.channel.options);

			if (this.options.channels) {

				// change the array of channel ids to array of objects {channel_id, channelDef_id}
				selectedChannels = this.options.channels.map((channel) => {
					if (typeof channel === 'string') {
						let channelDef = props.user.organisation.companySearchOrgChannels.edges.find(({node}) => {
							return node.realId === channel;
						});
						if (!channelDef) {
							return;
						}
						return {
							channel_id: channel,
							channelDef_id: channelDef.node.channelDef.realId
						};
					}

					return channel;
				}).filter((channel) => {
					return undefined !== channel;
				}).map((channel) => {
					let orgChannel = props.user.organisation.companySearchOrgChannels.edges.find(({node}) => {
						return node.realId === channel.channel_id;
					});

					if (undefined === orgChannel) {
						if (!props.user.organisation.companySearchSystemChannels.edges.find(({node}) => {
							return node.realId === channel.channelDef_id;
						})) {
							removedChannels.push(channel);
						}
					}

					return channel;
				});
			}
		}

		this.state = {
			selectedChannels: selectedChannels,
			channelsToBeAdded: [],
			removedChannels: removedChannels
		};
	}

	getActions(data) {
		let type = types[this.typeName];

		return [
			this.getDeleteButton({
				data: data,
				type: type,
				deleteTitle: (<FormattedMessage defaultMessage="Remove Company Search" id="channels.companySearch.remove" />)
			})
		];
	}

	renderChannels() {
		return this.state.selectedChannels.map((channel) => {
			let channelNode = this.props.user.organisation.companySearchOrgChannels.edges.find(({node}) => {
				return node.realId === channel.channel_id;
			});

			if (channelNode) {
				return channelNode.node;
			}

			return undefined;
		}).filter((channel) => {
			return channel !== undefined;
		}).sort((channelA, channelB) => {
			return this.getName(channelA).localeCompare(this.getName(channelB));
		}).map((channel, idx) => {
			return (
				<div className="checkChannel" key={idx}>
					<ChannelIcon channelDef={channel.channelDef} size={32}/> {this.getName(channel)}
				</div>
			);
		});
	}

	renderRemovedChannels() {
		if (this.state.removedChannels.length === 0) {
			return null;
		}

		return (
			<div className="removedApplications">
				<h3><FormattedMessage defaultMessage="Disconnected applications:" id="channels.companySearch.removedApplications" /></h3>
				<span><FormattedMessage defaultMessage="These applications are disconnected and aren't longer used." id="channels.companySearch.removedApplicationsNote" /></span>
				<div>{
					this.state.removedChannels.map((removedChannel, idx) => {
						const queryConfig = {
							queries: meQuery,
							name: 'User',
							params: {
								channelDefId: removedChannel.channelDef_id
							}
						};

						return (
							<Relay.Renderer
								Container={RemovedChannelView}
								environment={Relay.Store}
								key={idx}
								onReadyStateChange={({aborted, done, error}) => {
									// TODO indicate loading?
								}}
								queryConfig={queryConfig}
							/>
						);
					})
				}</div>
			</div>
		);
	}

	render() {
		const data = this.props.user.organisation.channel;

		let title = this.getName(data);

		return (
			<AppPanel breadcrumbParams={this.getBreadcrum()} className="ChannelView CompanySearch" title={title}>
				<h3><FormattedMessage defaultMessage="Connected application" id="application.connectedApplicationTitle" /></h3>
				<ChannelHeader actions={this.getActions(data)} data={data} organisation={this.props.user.organisation} title={title}>
					{data.channelDef.description ? <p>{data.channelDef.description}</p> : null}
				</ChannelHeader>
				<p>
					<FormattedMessage defaultMessage="Search for companies by email in different applications for best result." id="channels.companySearch.info" />
				</p>
				<div>
					<h3 key="-1"><FormattedMessage defaultMessage="Searched applications:" id="channels.companySearch.yourApplications" /></h3>
					{this.renderChannels()}
				</div>
				{this.renderRemovedChannels()}
				{
					BrowserPermission.hasOrganisationPermission(Permission.PERM_EDIT_CHANNEL, this.props.user.organisation.realId)
						? (<div className="saveToolbar">
							<Link className="btn btn-primary" key="1" to={urlMapping.getUrl(types[this.typeName], "options", data)}>
								<i aria-hidden="true" className="fa fa-fw fa-pencil"></i> <FormattedMessage defaultMessage="Change" id="operation.edit" />
							</Link>
						</div>)
						: null
				}
			</AppPanel>
		);
	}
}

// TODO clear the request fields from unnecessary items
export default Relay.createContainer(wrapNotFound(injectIntl(CompanySearch), (props) => {
	return props.user.organisation && props.user.organisation.channel;
}), {
	initialVariables: {
		organisationId: '',
		channelId: '',
		timestamp: '',
	},
	prepareVariables (variables) {
		if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

		return variables;
	},
	fragments: {
		user: () => Relay.QL`
			fragment on User {
				featureFlags,
				organisation(id: $organisationId) {
					id,
					name,
					featureFlags,
					channel(id: $channelId) {
						id,
						realId,
						organisation_id,
						type,
						cachingStatus,
						cachingInProgressJob {
							id,
							progress,
							status
						},
						confidential,
						description,
						name,
						lastCachingRefresh,
						metadata,
						options,
						channelDef {
							id,
							name,
							description,
							icon,
							virtual,
							metadata,
							urlFragment,
							usageDataSource,
						},
						${InvokeChannelJobMutation.getFragment('channel')},
					},
					companySearchSystemChannels(first: 100) {
						edges {
							node {
								id,
								realId,
								name,
								description,
								icon,
								virtual,
								metadata,
								urlFragment,
							}
						}
					},
					companySearchOrgChannels(first: 100, timestamp: $timestamp) {
						edges {
							node {
								id,
								realId,
								organisation_id,
								type,
								cachingStatus,
								cachingInProgressJob {
									id,
									progress,
									status
								},
								confidential,
								description,
								name,
								lastCachingRefresh,
								metadata,
								channelDef {
									id,
									realId,
									name,
									description,
									icon,
									virtual,
									metadata,
									urlFragment,
									usageDataSource,
								}
							}
						}
					}
				}
			}
		`,
	},
});
